var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.name),expression:"data.name"}],staticClass:"c-state",style:(_vm.compStyle),attrs:{"tag":_vm.tag}},[_vm._v(_vm._s(_vm.data.name))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }